module.exports = __webpack_public_path__ + "static/media/lgo-redirect.8db39464.svg";